var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5656 0.00488281H3.76795C2.14284 0.00488281 0.960938 1.18678 0.960938 2.81189V35.6096C0.960938 37.087 2.29057 38.4166 3.76795 38.4166H36.5656C38.1908 38.4166 39.3727 37.2347 39.3727 35.6096V2.81189C39.3727 1.18678 38.043 0.00488281 36.5656 0.00488281ZM12.7799 32.5071H6.87043V14.7786H12.7799V32.5071ZM9.82518 12.4148C7.90459 12.4148 6.27948 10.7897 6.27948 8.86913C6.27948 6.94854 7.90459 5.32343 9.82518 5.32343C11.7458 5.32343 13.3709 6.94854 13.3709 8.86913C13.3709 10.7897 11.7458 12.4148 9.82518 12.4148ZM33.4632 32.5071H27.5537V23.6429C27.5537 21.2791 26.9627 18.9153 24.5989 18.9153C22.2351 18.9153 21.6442 21.2791 21.6442 23.6429V32.5071H15.7347V14.7786H21.6442V16.8469H21.9396C22.6783 15.3696 24.5989 14.1877 26.815 14.1877C32.2813 14.1877 33.4632 17.7334 33.4632 22.1655V32.5071Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f7ebdeea6f9bc87a4a9be946ef70ef2e.svg";
export { ForwardRef as ReactComponent };